import * as XLSX from 'xlsx';

// Ruta absoluta web que coincide exactamente con tu estructura api/reportes/stockmin.js
const API = "/api/stockmin";

/**
 * Obtiene los productos que están igual o por debajo de su stock mínimo desde la Edge Function
 * @returns {Promise<Array>} Lista de productos en estado crítico
 */
export const getProductosStockCritico = async () => {
  try {
    const response = await fetch(API, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    // Validamos primero el estado HTTP para frenar respuestas HTML/Texto plano (como el 404 de Netlify)
    if (!response.ok) {
      throw new Error(`Error en el servidor de reportes (Código: ${response.status})`);
    }

    return await response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Recibe el array de productos críticos y dispara la descarga automática del archivo Excel (.xlsx)
 * @param {Array} productos - Datos crudos devueltos por la base de datos
 */
export const exportarStockCriticoExcel = (productos) => {
  try {
    if (!productos || productos.length === 0) {
      throw new Error("No hay productos con stock crítico para exportar.");
    }

    // 1. Mapeamos y formateamos las columnas para el Excel
    // OJO: Postgres devuelve 'stock_min' en minúsculas con guion bajo, aseguramos la lectura con p.stock_min
    const datosFormateados = productos.map((p) => ({
      "Código": `#${p.productos_id}`,
      "Nombre del Producto": p.nombre,
      "Categoría": p.categoria,
      "Stock Actual": p.stock,
      "Stock Mínimo": p.stock_min || p.stockMin, // Soporta ambos formatos por si acaso
      "Precio Compra": `S/ ${Number(p.precio_compra || 0).toFixed(2)}`,
      "Precio Venta": `S/ ${Number(p.precio_venta || 0).toFixed(2)}`,
      "Fecha de Vencimiento": p.fecha_vencimiento || 'N/A'
    }));

    // 2. Creamos el libro de trabajo (Workbook) y la hoja (Worksheet)
    const hoja = XLSX.utils.json_to_sheet(datosFormateados);
    const libro = XLSX.utils.book_new();
    
    // 3. Añadimos la hoja al libro con un nombre representativo
    XLSX.utils.book_append_sheet(libro, hoja, "Stock Crítico Almacén");

    // 4. Generamos el archivo con la fecha de hoy en formato YYYY-MM-DD
    const fechaHoy = new Date().toISOString().split('T')[0];
    const nombreArchivo = `Reporte_Stock_Critico_${fechaHoy}.xlsx`;
    
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // En iOS descargas directo usando la gestión de archivos nativa de Safari
        XLSX.writeFile(libro, nombreArchivo);
    } else {
        // En Android / Escritorio, generamos el buffer y forzamos la descarga con su nombre real
        const excelBuffer = XLSX.write(libro, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        const url = URL.createObjectURL(blob);
        
        // Creamos un elemento 'a' invisible en memoria
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo; // 👈 Aquí le inyectamos el nombre real del reporte
        
        // Añadimos al documento, hacemos click y removemos inmediatamente
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Limpiamos el objeto URL de la memoria de manera segura
        setTimeout(() => URL.revokeObjectURL(url), 250); 
    }

  } catch (error) {
    throw new Error("Error al generar el Excel: " + error.message);
  }
};